import { atom } from 'recoil';

// List display modes
export type ListMode = 'desktop' | 'mobileList' | 'mobileSwiper' | 'route' | 'filter' | 'mobileNavigation' | 'mobileAddPlace' | 'desktopAddPlace' | 'desktopNotifications' | 'mobileUserPlannedTour' | 'mobileUserPlannedTourResults';

// Current list mode state (null means default/no specific mode)
export const atom_listModeState = atom<ListMode | null>({
    key: 'listModeState',
    default: 'mobileSwiper',
});

// Mobile list height in pixels (for responsive adjustments)
export const atom_mobileListHeight = atom<number>({
    key: 'mobileListHeight',
    default: 0,
});

// CTA notification panel height in pixels. Fly helpers add this (or take max with
// mobileListHeight) when computing bottom padding so pins don't end up behind the panel.
export const atom_ctaPanelHeight = atom<number>({
    key: 'ctaPanelHeight',
    default: 0,
});
